import React from 'react';
import qs from 'query-string';
import moment from 'moment';

import BookAutocomplete from '../components/BookAutocomplete';
import BookDetails from '../components/BookAutocomplete/BookDetails';

import './CreateClassifiedPage.less';
import CreateClassifiedForm from '../components/CreateClassifiedForm';
import FormHint from '../components/FormHint';
import { getBaseUrl } from '../utils/config';
import { getBook, searchBook } from '../utils/api/bookApi';
import UserFeedback from '../components/UserFeedback';

moment.locale('nb');

export const createClassifiedPageId = 'createClassifiedWrapper';

const getBookUrl = (book, classifiedId) => {
  if (!book || !book.isbn) {
    return '';
  }

  return `${getBaseUrl()}bok/${book.isbn}/?focus_on=${classifiedId}`;
};

const getPreselectedIsbn = () => {
  const { search } = window.location;

  if (!search) {
    return null;
  }

  const { isbn = null } = qs.parse(search);

  return !isbn ? null : isbn;
};

const getBookFromIsbn = async (isbn) => {
  const book = await getBook(isbn).catch(() => null);

  if (book) {
    return book;
  }

  const results = await searchBook(isbn).catch(() => []);

  return results.find((result) => `${result.isbn}` === `${isbn}`) || results[0] || null;
};

class CreateClassifiedPage extends React.Component {
  state = {
    selectedIsbn: getPreselectedIsbn(),
    selectedBook: null,
    missingBookQuery: null,
    storedClassified: null,
  };

  componentDidMount() {
    const { selectedIsbn: isbn } = this.state;

    if (!isbn) {
      return;
    }

    getBookFromIsbn(isbn).then((book) => {
      if (!book) {
        this.setState({ missingBookQuery: isbn });
        return;
      }

      this.setState({
        missingBookQuery: null,
        selectedBook: book,
        selectedIsbn: book.isbn,
      });
    });
  }

  chooseBook = (book) => {
    this.setState({ missingBookQuery: null, selectedBook: book });
  };

  onClassifiedCreated = (classified) => {
    this.setState({ storedClassified: classified });
  };

  render() {
    const { storedClassified } = this.state;

    return <article>
      <h1>Opprett annonse</h1>

      <div className="createclassified">
        <div>
          <h2 className="createclassified__header">1. Finn boken</h2>
          <BookAutocomplete
            onSelect={this.chooseBook}
            selectedItem={this.state.selectedBook}
            initialQuery={this.state.selectedIsbn}
            hint={<FormHint>
              Finn boken du ønsker å selge, ved å søke etter tittel, isbn, forfatter,
              fagkode eller forlag.
            </FormHint>}
          />

          {this.state.missingBookQuery && <UserFeedback status="info" showIcon={false}>
            Ingen resultater for søket ditt.
          </UserFeedback>}

          {this.state.selectedBook && <div>
            <h4>Valgt</h4>

            <BookDetails book={this.state.selectedBook}/>
          </div>}
        </div>

        <div className="createclassified__form">
          <h2 className="createclassified__header">2. Legg inn informasjon</h2>

          <CreateClassifiedForm
            onComplete={this.onClassifiedCreated}
            bookIsbn={this.state.selectedBook ? this.state.selectedBook.isbn : null}
          />
        </div>

        {storedClassified && <UserFeedback status="success">
          Annonsen din har blitt publisert og
          utløper {moment(storedClassified.expiration_date).fromNow()}.
          Du kan se annonsen din her: <a
          href={getBookUrl(this.state.selectedBook, storedClassified.classified_id)}>
          {this.state.selectedBook.title}</a>,
          og administrere annonsen på <a href={`${getBaseUrl()}mine_annonser/`}>Mine annonser</a>.
        </UserFeedback>}
      </div>
    </article>;
  }
}

export default CreateClassifiedPage;
